export default function install(Vue, translations) {
    Vue.filter('translate', (key) => {
        try {
            return key.split('.').reduce((translations, key) => {
                if (translations.hasOwnProperty(key)) {
                    return translations[key]
                } else {
                    throw 'Translation not found for key:' + key
                }
            }, translations)
        } catch (error) {
            console.error(error);
            return 'translate:' + key
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/vue-translation-plugin.js